'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import * as ProgressPrimitive from '@radix-ui/react-progress';
import * as React from 'react';
import { cn } from '../../../lib/utils';
const Progress = /*#__PURE__*/ React.forwardRef(({ className, value, ...props }, ref)=>/*#__PURE__*/ _jsx(ProgressPrimitive.Root, {
        ref: ref,
        className: cn('relative h-2 w-full overflow-hidden rounded-full bg-primary/20', className),
        ...props,
        children: /*#__PURE__*/ _jsx(ProgressPrimitive.Indicator, {
            className: "h-full w-full flex-1 bg-primary transition-all",
            style: {
                transform: `translateX(-${100 - (value || 0)}%)`
            }
        })
    }));
Progress.displayName = ProgressPrimitive.Root.displayName;
export { Progress };
